import styled from 'styled-components';

export const StyledContainer = styled.div`
  left: 8px;
  right: 8px;
  bottom: 8px;
  height: 80px;
  z-index: 100;
  position: absolute;
  text-align: center;
  border-radius: 5px;
  background-color: var(--error100);

  &:hover {
    cursor: pointer;
  }
`;

export const StyledTitle = styled.p`
  color: var(--grey900);
  font-weight: bold;
  margin-bottom: 5px;
`;

export const StyledDescription = styled.p`
  color: var(--grey900);
  margin-top: 5px;
`;

export const StyledCloseButton = styled.div`
  position: absolute;
  top: 9px;
  right: 13px;
`;
